import { useEffect, useState } from 'react'
import { useNav, useParseQuery } from '../../../../hooks/useNav'
import { LuEye } from 'react-icons/lu'
import { Icon } from '@iconify/react'
import TableData from '../../../../components/ui/TableData'
import { FaRegTrashAlt } from 'react-icons/fa'
// import { Button } from '../../../../modules/common/components/Form'
// import { PAGE_SIZE } from '../../../../constants/constants'

import useGetAdmins from '../hooks/useGetAdmins'

import { PAGE_SIZE } from '../../../../data/queryFactories'
import { PATH } from '../../../../data/router_path'
import ExportExcel from './ExportExcelAdmin'
import { accountService } from '../../../../service/AccountService'
import ConfirmationBox from '../../../../components/ui/ConfirmationBox'
export default function AdminPermissionDataTable() {
  const navigate = useNav()
  const { queryParams } = useParseQuery()
  const {
    data: { totalResult = 0, totalPages = 0, admins = [] },
    isLoading,
  } = useGetAdmins()
  const [activeAdmin, setActiveAdmin] = useState(null)

  const [currentPage, setCurrentPage] = useState(1)
  const [currentAdmin, setCurrentAdmin] = useState([])
  const [popupConfirmRemovedmin, setPopupConfirmRemoveAdmin] = useState(false)
  const [rowCurrent, setRowCurrent] = useState({})
  useEffect(() => {
    const pageNumber = queryParams?.pageNumber ?? 1
    setCurrentPage(Number(pageNumber))
  }, [queryParams])
  useEffect(() => {
    // Slice data dựa trên currentPage và PAGE_SIZE
    if (admins.length > 0) {
      const startIndex = (currentPage - 1) * PAGE_SIZE
      const endIndex = startIndex + PAGE_SIZE
      setCurrentAdmin(admins.slice(startIndex, endIndex))
    }
  }, [admins, currentPage])

  const columnMapping = [
    { key: 'id', value: 'Mã tài khoản' },
    { key: 'name', value: 'Tên tài khoản' },
    { key: 'permitedBy', value: 'Người phân quyền' },
    { key: 'permitedDate', value: 'Ngày phân quyền' },
    { key: 'email', value: 'Email trường' },
    { key: 'personalEmail', value: 'Email cá nhân' },
    { key: 'phoneNumber', value: 'Số điện thoại' },
    { key: 'groups', value: 'Quyền hạn' },
  ]

  const columnWidths = {
    id: 'w-[19vw]',
    name: 'w-[19vw]',
    permitedBy: 'w-[19vw]',
    permitedDate: 'w-[19vw]',
    email: 'w-[19vw]',
    personalEmail: 'w-[19vw]',
    phoneNumber: 'w-[19vw]',
    groups: 'w-[19vw]',
  }
  const handleDeleteAdmin = async (row) => {
    const res = await accountService.deleteAdmin(row?.uuid)
    if (res?.meta?.code === 200) {
      window.location.reload()
    }
  }
  const actionButtons = [
    {
      title: 'Xem chi tiết tài khoản admin',
      icon: <LuEye className="text-2xl text-main-grey" />,
      onClick: (row) => {
        handleDetailView(row)
      },
      label: 'Xem chi tiết tài khoản admin',
    },
    {
      titl: 'Xóa tài khoản admin',
      icon: <FaRegTrashAlt className="text-2xl text-red-500" />,
      onClick: (row) => {
        setRowCurrent(row)
        setPopupConfirmRemoveAdmin(true)
        // handleDeleteAdmin(row)
      },
    },
  ]
  const handleDetailView = (row) => {
    navigate(PATH.SYSTEM.DETAIL(row.uuid))
  }
  return (
    <>
      <TableData
        data={currentAdmin}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        actionButtons={actionButtons}
        paginationEnabled={true}
        dataType="tài khoản quản trị viên"
        currentPage={currentPage}
        totalPages={totalPages} // Tính tổng số trang dựa trên dữ liệu thật
        PAGE_SIZE={PAGE_SIZE}
        totalItems={totalResult} // Tổng số lỗi thực tế
        path={PATH.SYSTEM.DECENTRALIZE_ADMINISTRATION.LIST}
        extraFunctions={[<ExportExcel />]}
        detailView={handleDetailView}
      />
      {popupConfirmRemovedmin && (
        <ConfirmationBox
          message={
            <span className="mb-1 py-2">
              Xác nhận xóa tài khoản Admin? <br />
              <p className="text-black"> Thao tác này sẽ không thể hoàn tác</p>
            </span>
          }
          className="text-main-red"
          onConfirm={() => handleDeleteAdmin(rowCurrent)}
          onCancel={() => setPopupConfirmRemoveAdmin(false)}
        />
      )}
    </>
  )
}
